import React from "react";
import {defineBlock, smartProps,EditableImg,EditableDiv} from "@smartfire/wordpress-react";
import style from "./block.module.scss";


function Block(){
    return <div className={style.block}>
        <EditableImg smartProp="image" className={style.image}/>
        <div className={style.content}>
            <EditableDiv smartProp='title' className={style.title}/>
            <EditableDiv smartProp='text' className={style.text}/>
        </div>
    </div>
}

export default defineBlock({
    Block,
    smartProps: {
        image: smartProps.any.withDefault(""),
        title: smartProps.string.withDefault("Construction hors-site"),
        text: smartProps.string.withDefault("Easycube déploie une solution constructive hors-site, de la conception à la réalisation de votre projet partout dans le monde."),
    }, 
    setup: {
        title: "Pictos footer Item",
        parent:['smartfire/pictos-footer']
    }
});
